import requestUtil from "../../../../helpers/requestUtil";
import { setCandidateSearchInfo, setMasterData, setError, resetError, setParams, resetParams } from './slice';
import { setLoading } from "../../../common/Loader/slice";
import * as Toasts from '../../../common/Toastify'


export const updateParams = (data) => {
    return async dispatch => {
        dispatch(setParams(data));
    };
}

export const resetParamVal = () => {
    return async dispatch => {
        dispatch(resetParams());
    };
}

export const getCandidateSearchDetail = ({ url, params }) => {
    const newparams = { ...params };
    newparams.locationId = params.locationId ? params.locationId : 0;
    newparams.distanceId = params.distanceId ? params.distanceId : 0;
    newparams.distance = params.distance ? parseInt(params.distance) : 0;
    newparams.status = params.status.map(item => item.id);
    return async dispatch => {
        dispatch(setLoading(true));
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...newparams });
            formartData(response.candidateSearchList)
            dispatch(setCandidateSearchInfo(response.candidateSearchList));
        } catch (error) {
            dispatch(setError(error.message))
        }
        dispatch(setLoading(false));
    };
}

export const loadMasterData = (baseUrl, empuniqueId) => {
    return async dispatch => {
        dispatch(setLoading(true));
        try {
            const location = await requestUtil(`${baseUrl}/Locations/get-location-list-for-dropdown/${empuniqueId}`, 'GET');
            const status = await requestUtil(`${baseUrl}/Dropdown/get-candidate-status-for-employer-search`, 'GET');
            const newstatus = await requestUtil(`${baseUrl}/Dropdown/get-candidate-status-for-employer-status-update-dropdown`, 'GET');
            const travelDistance = await requestUtil(`${baseUrl}/Dropdown/GetTravelDistances`, 'GET');
            // location.unshift({id: "", name: "Select"})
            // console.log(location);
            dispatch(setMasterData({ location, status, newstatus,travelDistance }));
        } catch (error) {
            dispatch(setError(error.message))
        }
        dispatch(setLoading(false));
    };
}

const formartData = (data) => {
    data.map(item => {
        item.shiftsCompleted = item.shiftsCompleted ? `${item.shiftsCompleted} Shifts` : "";
        item.hoursWorked = item.hoursWorked ? `${item.hoursWorked} Hours` : "";
        item.distance = item.distance ? `${item.distance} miles` : "";
    });
}

export const updateStatus = ({ url, params }) => {
    return async dispatch => {
        dispatch(setLoading(true));
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            Toasts.success(response.message);
        } catch (error) {
            dispatch(setError(error.message))
        }
        dispatch(setLoading(false));
    }
}
